import React from 'react';
import FavouriteSection from './FavouriteSection';
import { useSparkFavourites } from 'hooks/Favourites';

function FavouriteTabContent() {
  const { sparksGroupedByFavouriteID, isLoading } = useSparkFavourites();
  const favouriteSparks = Object.values(sparksGroupedByFavouriteID || {});

  return (
    <>
      {favouriteSparks?.map((favouriteSpark) => (
        <FavouriteSection
          sparkFav={favouriteSpark}
          isLoading={isLoading}
          key={favouriteSpark.favourite.id}
        />
      ))}
    </>
  );
}

export default FavouriteTabContent;
